import { Box, Typography, Link } from "@mui/material";

const TopCampaignsCard = () => (
  <Box sx={{
    background: 'linear-gradient(135deg, #f9fbe7 0%, #f8fafc 100%)',
    borderRadius: 2,
    border: '1px solid #e3e7ed',
    boxShadow: '0 2px 8px 0 rgba(99, 99, 99, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    px: 3,
    py: 2.5,
    gap: 1.5,
    height: '100%',
    fontFamily: 'Montserrat, Arial, sans-serif',
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.03)',
      boxShadow: '0 4px 20px 0 rgba(99, 99, 99, 0.2)',
    }
  }}>
    <Typography variant="subtitle1" sx={{ color: '#7cb342', fontWeight: 700, mb: 1 }}>
      Campagnes Marketing
    </Typography>
    <Box>
      <Typography sx={{ fontWeight: 600, color: '#1976d2', fontSize: 15 }}>
        ● Promo Printemps
      </Typography>
      <Typography sx={{ color: '#495057', fontSize: 14 }}>
        Conversion : <span style={{ color: '#1976d2', fontWeight: 600 }}>+8%</span> sur les VIP.<br />
        <span style={{ color: '#388e3c', fontWeight: 600 }}>Objectif atteint</span>
      </Typography>
    </Box>
    <Box>
      <Typography sx={{ fontWeight: 600, color: '#43a047', fontSize: 15 }}>
        ● Relance Inactifs
      </Typography>
      <Typography sx={{ color: '#495057', fontSize: 14 }}>
        Taux d’ouverture : 18%. <br />
        <span style={{ color: '#868e96', fontWeight: 600 }}>En cours</span>
      </Typography>
    </Box>
    <Box mt="auto" pt={2}>
      <Link href="/campagne" sx={{ color: '#7cb342', fontWeight: 600, fontSize: 15, textDecoration: 'underline' }}>
        Voir toutes les campagnes
      </Link>
    </Box>
  </Box>
);

export default TopCampaignsCard;
